import React, { useContext } from 'react';
import FlatList from '@/components/FlatList';
import RenderList from './RenderList';
import { OrderContext } from '../context';

export function ListBody() {
  const { isLoading, loadMoreData, pagination } = useContext(OrderContext);

  return (
    <FlatList
      isLoaderVisible={isLoading}
      isNext={pagination?.isNext}
      onScrollEnd={() => loadMoreData()}
      renderList={() => <RenderList />}
      renderInsideFragment
    />
  );
}

export default ListBody;
